import {
  loginSuccess,
  setUserProfile,
  logout,
  setAccessToken,
  setInitialized,
} from "../slices/authSlice";
import axiosInstance from "../../services/http";
import { jwtDecode } from "jwt-decode";
import { logoutService } from "../../services/authService";

// Initialize authentication on app load
export const initializeAuth = () => async (dispatch) => {
  try {
    const existingToken = localStorage.getItem("authToken");
    if (existingToken) {
      dispatch(setAccessToken(existingToken));

      const decodedToken = jwtDecode(existingToken);
      const isAdmin = decodedToken.is_admin;
      dispatch(loginSuccess({ is_admin: isAdmin }));
    } else {
      // Attempt to refresh the access token
      const refreshResponse = await axiosInstance.post("token/refresh/");
      const { access } = refreshResponse.data;
      dispatch(setAccessToken(access));

      // Decode the access token to get is_admin
      const decodedToken = jwtDecode(access);
      const isAdmin = decodedToken.is_admin;
      dispatch(loginSuccess({ is_admin: isAdmin }));
    }
  } catch (error) {
    // If refresh fails, log out
    dispatch(logout());
  } finally {
    dispatch(setInitialized());
  }
};

// Login action
export const login = (username, password, rememberMe) => async (dispatch) => {
  try {
    const lowerCasedUsername = username.trim().toLowerCase(); // Make the username case-insensitive
    const response = await axiosInstance.post(
      "token/",
      {
        username: lowerCasedUsername,
        password,
      },
      { skipGlobalError: true }
    );
    const { access } = response.data;
    dispatch(setAccessToken(access));

    if (response.status === 200) {
      // Decode the access token to get is_admin
      const decodedToken = jwtDecode(access);
      const isAdmin = decodedToken.is_admin;

      dispatch(setAccessToken(access));
      dispatch(loginSuccess({ is_admin: isAdmin }));

      localStorage.setItem("authToken", access);

      // Now fetch user account details from the dedicated endpoint
      const profileResponse = await axiosInstance.get("user/profile/");
      dispatch(setUserProfile(profileResponse.data));

      // Handle 'remember me' setting
      if (rememberMe) {
        localStorage.setItem("remember_me", "true");
      } else {
        localStorage.removeItem("remember_me");
      }

      return { success: true, is_admin: isAdmin };
    } else {
      console.error("Unexpected response status:", response.status);
      return { success: false, message: "Unexpected response status." };
    }
  } catch (error) {
    console.error("Login failed:", error);

    // Extract the error message from the response
    const errorMessage =
      error.response?.data?.detail || "Login failed. Please try again.";

    return { success: false, message: errorMessage };
  }
};

// Logout action
export const logoutAction = () => async (dispatch) => {
  const response = await logoutService();
  if (response.status === 200) {
    dispatch(logout());
    window.location.replace("/login"); // Redirect to login page after logout with deleting browser history
  }
};

// Verify session (if needed)
export const verifySession = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get("verify-session/");
    const { is_admin } = response.data;

    dispatch(loginSuccess({ is_admin }));

    return { success: true, is_admin };
  } catch (error) {
    console.error("Session verification failed:", error);
    dispatch(logout());

    return { success: false };
  }
};
